import React, { forwardRef, useEffect, useState } from 'react';
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBIcon,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
    MDBBadge,
    MDBInput,
    MDBSpinner,
    MDBRow,
    MDBCol,
    MDBTable,
    MDBTableHead,
    MDBTableBody,
    MDBAlert,
    MDBTypography,
    MDBModalFooter
} from 'mdb-react-ui-kit';
import moment from 'moment';
import { getMembersBySchedule, getMembersBySchedulewithplans } from '../services/memberApiServices';
import { checkMembers, checkMembershipDiscount, classCheckinsByGymID, downloadclassinvoice, getGBussinessInfo, getMemberTransactions } from '../services/apiServices';
import AddUsers from "../views/AddUsers.js";
import { useNavigate } from 'react-router';
import DatePicker from "react-datepicker";
import { addDays } from 'date-fns';
import calImg from "./../components/images/calendar.svg";
import { BasePlanName } from '../utils/BasePlanName';


const ClassCheckIn = ({ scheduleInfo, classes, trainerData, policyData, usersData, onInvoiceStateChange, plans, onInvoiceRequest }) => {


    const [filteredClasses, setFilteredClasses] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState('relevant');


    const [searchClassQuery, setSearchClassQuery] = useState('');
    const [refreshKey, setRefreshKey] = useState(0);
    const [expandedClasses, setExpandedClasses] = useState({});

    const [showAddMemberModal, setShowAddMemberModal] = useState(false);
    const [classParticipants, setClassParticipants] = useState({});
    const [loadingParticipants, setLoadingParticipants] = useState({});
    const [selectedClassForAdd, setSelectedClassForAdd] = useState(null);
    const [checkinLoading, setCheckinLoading] = useState({});
    const [alertMessage, setAlertMessage] = useState({ type: '', text: '', show: false });


    const [curIndex, setCurIndex] = useState(0);
    const [submitFlag, setSubmitFlag] = useState(false);
    const [selectedevent, setSelectedevent] = useState(null);
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [bussinessinfo, setbusinessinfo] = useState(null);

    const [discountData, setDiscountData] = useState([]);
    const [invoiceCheck, setInvoiceCheck] = useState(false);

    const navigate = useNavigate();
    const [showClassInfoModal, setShowClassInfoModal] = useState(false);
    const [selectedClassInfo, setSelectedClassInfo] = useState(null);

    const [classCheckins, setClassCheckins] = useState([]);

    const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, endDate] = dateRange;
    const [dayFilter, setDayFilter] = useState('');

    useEffect(() => {
        if (onInvoiceStateChange) {
            onInvoiceStateChange(invoiceCheck);
        }
    }, [invoiceCheck, onInvoiceStateChange]);

    const getGymId = () => {
        const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
        return userInfo || -1;
    };

    const handleViewClassInfo = (e, session) => {
        e.stopPropagation(); // prevent expand/collapse
        setSelectedClassInfo(session);
        setShowClassInfoModal(true);
    };



    function getToken() {
        try {
            const tokenString = localStorage.getItem("transactionId");
            return tokenString;
        } catch (e) {
            console.log("error :::::: " + e);
            return;
        }
    }


    useEffect(() => {
        const fetchBusiness = async () => {
            const loggedUser = localStorage.getItem("loggedUserInfo");
            if (!loggedUser) return;

            const gymId = getGymId();
            if (gymId === -1) return;

            const response = await getGBussinessInfo(gymId);
            if (!response || response === "false") return;

            const recinfo = await response.json();
            if (recinfo) {
                setbusinessinfo(recinfo);
            }
        };

        fetchBusiness();
    }, []);




    useEffect(() => {
        const fetchClassCheckins = async () => {
            if (!localStorage.getItem("loggedUserInfo")) return;

            let gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
            const response = await classCheckinsByGymID(gymid, { gymid: gymid });
            if (!response || response === "false") return;

            const checkinData = await response.json();
            setClassCheckins(checkinData);
        };

        fetchClassCheckins();
    }, []);



    // Check membership discount
    useEffect(() => {
        const checkMembership = async () => {
            if (!selectedevent?.classInfo?.membershipdiscount?.length) return;

            const update = {
                memebership: selectedevent.classInfo.membershipdiscount,
                memebersid: selectedMembers.map(m => m._id)
            };

            const membersinfo = await checkMembershipDiscount(getGymId(), update, "user");
            if (!membersinfo || membersinfo === "false") {
                return;
            }
            const members = await membersinfo.json();
            setDiscountData(members?.discountEligibleMembers || []);
        };

        if (selectedevent && invoiceCheck) {
            checkMembership();
        }
    }, [invoiceCheck, selectedevent, selectedMembers]);

    // Process class sessions based on schedule data
    const processClassSessions = () => {
        setLoading(true);
        const now = moment();
        const today = now.clone().startOf('day');
        const yesterday = now.clone().subtract(1, 'day').startOf('day');
        const startOfWeek = now.clone().startOf('isoWeek'); // Monday as start of week
        const endOfWeek = now.clone().endOf('isoWeek');     // Sunday as end of week
        const startOfMonth = now.clone().startOf('month');
        const endOfMonth = now.clone().endOf('month');
        const startOfYear = now.clone().startOf('year');
        const endOfYear = now.clone().endOf('year');
        const twoHoursAgo = moment().subtract(2, 'hours');
        const oneHourAhead = moment().add(1, 'hour');

        const sessions = [];


        scheduleInfo.forEach(schedule => {
            const classInfo = classes.find(cls => cls._id === schedule.classid);
            const trainerInfo = trainerData.find(trainer => trainer._id === schedule.trainerid);

            if (!classInfo) return;

            const timeslot = schedule.timeslot;
            if (!timeslot) return;

            const timeMatch = timeslot.match(/(\d{1,2}:\d{2}\s*[AP]M)/i);
            if (!timeMatch) return;

            const startTimeStr = timeMatch[1];
            const scheduleStartDate = moment(schedule.startdate);

            // Parse the time
            const parseTime = (timeStr) => {
                return moment(timeStr, ["hh:mm A", "HH:mm"]);
            };

            const timeOnly = parseTime(startTimeStr);

            // Create session start time
            const sessionStart = scheduleStartDate.clone();
            sessionStart.set({
                hour: timeOnly.hour(),
                minute: timeOnly.minute(),
                second: 0,
                millisecond: 0
            });

            // Apply Day Filter logic FIRST
            let shouldInclude = false;

            // CASE 1: Day filter is selected
            if (dayFilter) {
                if (dayFilter === '1') { // Today
                    const isToday = scheduleStartDate.isSame(today, 'day');
                    if (isToday && selectedFilter === 'relevant') {
                        const duration = parseInt(classInfo.duration) || 60;
                        const sessionEnd = sessionStart.clone().add(duration, 'minutes');
                        const isPastTwoHours = sessionStart.isBetween(twoHoursAgo, now, null, '[]');
                        const isUpcomingOneHour = sessionStart.isBetween(now, oneHourAhead, null, '[]');
                        const isInProgress = sessionStart.isBefore(now) && sessionEnd.isAfter(now);
                        const isRecentlyCompleted = sessionEnd.isBetween(twoHoursAgo, now, null, '[]') &&
                            scheduleStartDate.isSame(today, 'day');
                        shouldInclude = isPastTwoHours || isUpcomingOneHour || isInProgress || isRecentlyCompleted;
                    } else {
                        shouldInclude = isToday;
                    }
                } else if (dayFilter === '2') { // Yesterday
                    shouldInclude = scheduleStartDate.isSame(yesterday, 'day');
                } else if (dayFilter === '3') { // This Week
                    shouldInclude = scheduleStartDate.isBetween(startOfWeek, endOfWeek, 'day', '[]');
                } else if (dayFilter === '4') { // This Month
                    shouldInclude = scheduleStartDate.isBetween(startOfMonth, endOfMonth, 'day', '[]');
                } else if (dayFilter === '5') { // This Year
                    shouldInclude = scheduleStartDate.isBetween(startOfYear, endOfYear, 'day', '[]');
                } else if (dayFilter === '6') { // Custom
                    // For custom, use date range
                    if (startDate && endDate) {
                        const selectedStart = moment(startDate).startOf('day');
                        const selectedEnd = moment(endDate).endOf('day');
                        shouldInclude = scheduleStartDate.isBetween(
                            selectedStart,
                            selectedEnd,
                            'day',
                            '[]'
                        );
                    } else {
                        // If custom selected but no date range, show nothing
                        shouldInclude = false;
                    }
                }
            }
            // CASE 2: Date range is selected (without day filter)
            else if (startDate && endDate) {
                const selectedStart = moment(startDate).startOf('day');
                const selectedEnd = moment(endDate).endOf('day');
                shouldInclude = scheduleStartDate.isBetween(
                    selectedStart,
                    selectedEnd,
                    'day',
                    '[]'
                );
            }
            // CASE 3: No day filter or date range - use selectedFilter
            else {
                if (selectedFilter === 'relevant') {
                    // Calculate session end time for status checking
                    const duration = parseInt(classInfo.duration) || 60;
                    const sessionEnd = sessionStart.clone().add(duration, 'minutes');

                    const isPastTwoHours = sessionStart.isBetween(twoHoursAgo, now, null, '[]');
                    const isUpcomingOneHour = sessionStart.isBetween(now, oneHourAhead, null, '[]');
                    const isInProgress = sessionStart.isBefore(now) && sessionEnd.isAfter(now);
                    const isRecentlyCompleted = sessionEnd.isBetween(twoHoursAgo, now, null, '[]') &&
                        scheduleStartDate.isSame(today, 'day');

                    shouldInclude = isPastTwoHours || isUpcomingOneHour || isInProgress || isRecentlyCompleted;
                } else if (selectedFilter === 'all') {
                    shouldInclude = scheduleStartDate.isSame(today, 'day');
                }
            }

            // If session passes filter, add it
            if (shouldInclude) {
                // Calculate checked-in count
                const scheduleCheckins = classCheckins?.filter(
                    checkin => checkin.scheduleid == schedule._id
                ) || [];
                const uniqueMemberIds = new Set();
                scheduleCheckins.forEach(checkin => {
                    if (checkin.id) {
                        uniqueMemberIds.add(checkin.id.toString());
                    }
                });
                const checkedInCount = uniqueMemberIds.size;

                const duration = parseInt(classInfo.duration) || 60;
                const sessionEnd = sessionStart.clone().add(duration, 'minutes');

                // Calculate status
                let status = '';
                if (sessionStart.isAfter(now)) {
                    status = 'upcoming';
                } else if (sessionStart.isBefore(now) && sessionEnd.isAfter(now)) {
                    status = 'in-progress';
                } else if (sessionEnd.isBefore(now)) {
                    status = 'completed';
                }

                const enrolled = schedule.bookedslots || 0;
                const capacity = schedule.totalslots || parseInt(classInfo.slots) || 0;
                const available = capacity - enrolled;

                sessions.push({
                    id: `${schedule._id}-${scheduleStartDate.format('YYYY-MM-DD')}`,
                    scheduleId: schedule._id,
                    recurrenceid: schedule.recurrenceid,
                    className: classInfo.name,
                    classDescription: classInfo.description || '',
                    category: classInfo.category || 'General',
                    level: classInfo.level || 'All Levels',
                    instructor: trainerInfo
                        ? `${trainerInfo.firstname} ${trainerInfo.lastname}`
                        : 'Not Assigned',
                    instructorId: schedule.trainerid,
                    location: schedule.location || 'Main Studio',
                    startTime: sessionStart,
                    endTime: sessionEnd,
                    timeslot: schedule.timeslot,
                    sessionDate: scheduleStartDate.format('YYYY-MM-DD'),
                    duration: classInfo.duration,
                    capacity: capacity,
                    enrolled: enrolled,
                    available: available,
                    status: status,
                    checkedInCount: checkedInCount,
                    price: classInfo.price || '0',
                    scheduleData: schedule,
                    classData: classInfo,
                    trainerInfo: trainerInfo
                });
            }
        });

        // Apply search filter
        let filteredSessions = sessions.filter(session => {
            const matchesSearch = searchClassQuery === '' ||
                session.className.toLowerCase().includes(searchClassQuery.toLowerCase()) ||
                session.instructor.toLowerCase().includes(searchClassQuery.toLowerCase()) ||
                session.category.toLowerCase().includes(searchClassQuery.toLowerCase());

            return matchesSearch;
        });

        console.log("Total filtered sessions:", filteredSessions.length);

        // Sort by start time
        filteredSessions.sort((a, b) => a.startTime - b.startTime);
        setFilteredClasses(filteredSessions);
        setLoading(false);
    };


    useEffect(() => {
        if (scheduleInfo.length > 0 && classes.length > 0) {
            processClassSessions();
        }
    }, [scheduleInfo, classes, trainerData, selectedFilter, refreshKey, searchClassQuery, dateRange, classCheckins, dayFilter]);

    useEffect(() => {
        const interval = setInterval(() => {
            setRefreshKey(prev => prev + 1);
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    const loadParticipants = async (sessionId, classData, silent = false) => {

        const scheduleId = sessionId.split('-')[0];
        const sessionDate = sessionId.split('-')[1];

        console.log("scheduleId", scheduleId, "sessionDate", sessionDate);
        if (!classParticipants[sessionId]) {
            try {
                if (!silent) setLoadingParticipants(prev => ({ ...prev, [sessionId]: true }));

                // Fetch enrolled participants
                const updates = {
                    gymid: getGymId(),
                    scheduleId: scheduleId
                };
                const res = await getMembersBySchedulewithplans(scheduleId, updates);
                if (!res || res === "false") {
                    setClassParticipants(prev => ({ ...prev, [sessionId]: [] }));
                    return;
                }

                const data = await res.json();
                console.log("datadata", data);

                if (!data.tableData) {
                    setClassParticipants(prev => ({ ...prev, [sessionId]: [] }));
                    return;
                }

                // Get check-ins for this specific session date
                const sessionCheckins = classCheckins.filter(checkin => {
                    return checkin.scheduleid == scheduleId &&
                        moment(checkin.date).format('YYYY-MM-DD') === sessionDate;
                });

                console.log("sessionCheckins", sessionCheckins);

                // Map participants with check-in status
                const mappedParticipants = data.tableData.map((row) => {
                    const isCheckedIn = row.checkinflag === 1 ||
                        sessionCheckins.some(checkin => checkin.id == (row.id || row._id));


                    const planName = row?.baseplan
                        ? `${BasePlanName(plans, row?.baseplan)}-${row.planname}`
                        : row.planname || "No active plan";

                    return {
                        _id: row.id || row.sno || row._id,
                        orderId: row.orderId,
                        membername: row.membername,
                        number: row.number,
                        age: row.age,
                        gender: row.gender,
                        plan: planName,
                        checkedIn: isCheckedIn,
                        scheduletrans: row?.scheduleId
                    };
                });

                setClassParticipants(prev => ({
                    ...prev,
                    [sessionId]: mappedParticipants
                }));
            } catch (error) {
                console.error(`Error loading participants:`, error);
                setClassParticipants(prev => ({ ...prev, [sessionId]: [] }));
            } finally {
                if (!silent) setLoadingParticipants(prev => ({ ...prev, [sessionId]: false }));
            }
        }
    };

    useEffect(() => {
        filteredClasses.forEach(session => {
            loadParticipants(session.id, session, true);
        });
    }, [filteredClasses]);

    const toggleClassExpand = async (sessionId, classData) => {
        const willExpand = !expandedClasses[sessionId];

        setExpandedClasses(prev => ({
            ...prev,
            [sessionId]: willExpand
        }));

        if (willExpand) {
            await loadParticipants(sessionId, classData);
        }
    };

    const handleDirectCheckIn = async (sessionId, participant) => {


        const classData = filteredClasses.find(c => c.id === sessionId);

        // Prevent check-in for completed classes
        if (classData?.status === 'completed') {
            setAlertMessage({
                type: 'danger',
                text: `Cannot check in ${participant.membername}. This class has already completed.`,
                show: true
            });

            setTimeout(() => {
                setAlertMessage({ type: '', text: '', show: false });
            }, 3000);
            return;
        }

        const loadingKey = `${sessionId}-${participant._id}`;

        try {
            setCheckinLoading(prev => ({ ...prev, [loadingKey]: true }));

            const gymid = getGymId();
            const now = new Date();
            const classData = filteredClasses.find(c => c.id === sessionId);

            if (!classData) {
                throw new Error('Class not found');
            }


            const checkInTime = now.toISOString();
            const checkOutTime = classData.endTime.toISOString();
            const updates = {
                checkFlag: "1",
                mid: participant._id,
                _id: participant._id,
                date: checkInTime,
                gymid: gymid,
                selectedplan: null,
                Complementary: false,
                isSharedCheckin: false,
                includeMainMember: false,
                partnerGymId: null,
                sessionvalue: null,
                trainer: classData.instructor,
                trainerid: classData.instructorId,
                autocheckout: checkOutTime,
                scheduletransid: participant?.scheduletrans,
                fdate: checkInTime,
                tdate: classData.endTime.toISOString()
            };


            // console.log("sendingcheckindata :", updates);
            const res = await checkMembers(updates, participant._id);

            // console.log("Checinresponse:", res);

            if (!res || res === "false") {
                throw new Error('Check-in failed');
            }

            const result = await res.json();
            const isSuccess = (result && (result.status === true || result.staus === true));

            if (isSuccess) {
                setClassParticipants(prev => ({
                    ...prev,
                    [sessionId]: prev[sessionId].map(p =>
                        p._id === participant._id
                            ? { ...p, checkedIn: true, checkinTime: now.toISOString() }
                            : p
                    )
                }));

                const gymid = getGymId();
                const updatedCheckins = await classCheckinsByGymID(gymid, { gymid });
                if (updatedCheckins && updatedCheckins !== "false") {
                    const checkinData = await updatedCheckins.json();
                    setClassCheckins(checkinData);
                }

                setAlertMessage({
                    type: 'success',
                    text: `${participant.membername} checked in successfully!`,
                    show: true
                });

                setTimeout(() => {
                    setAlertMessage({ type: '', text: '', show: false });
                }, 3000);
            } else {
                throw new Error(result.message || 'Check-in failed');
            }
        } catch (error) {
            console.error('Error checking in participant:', error);

            setAlertMessage({
                type: 'danger',
                text: `${participant.membername} has already checked in. Please verify.`,
                show: true
            });


            setTimeout(() => {
                setAlertMessage({ type: '', text: '', show: false });
            }, 5000);
        } finally {
            setCheckinLoading(prev => ({ ...prev, [loadingKey]: false }));
        }
    };

    const formatTimeDisplay = (startTime, endTime) => {
        return `${startTime.format('h:mm A')} - ${endTime.format('h:mm A')}`;
    };

    const handleAddMemberClick = async (classData) => {
        // Reset states
        setSelectedMembers([]);

        // Create selected event object similar to BookSessions
        const policy = policyData.find(pol => pol?._id === classData.scheduleData.cancellationpolicyid) || {};
        const cancellationPolicy = policy?.cancelfee?.length > 0 ? policy.cancelfee.filter(fee => fee.checked) : [];

        const eventData = {
            classInfo: classData.classData,
            scheduleinfo: classData.scheduleData,
            trainerInfo: classData.trainerInfo,
            price: classData.price,
            trainer: classData.instructor,
            slotsBooked: classData.enrolled,
            slotsRemaining: classData.capacity,
            startTime: classData.startTime.format("hh:mm A"),
            endTime: classData.endTime.format("hh:mm A"),
            cancellationPolicy: cancellationPolicy,
            duration: classData.duration
        };

        setSelectedevent(eventData);
        setSelectedClassForAdd(classData);
        setShowAddMemberModal(true);
    };

    // Handler for when member is selected from AddUsers component
    const addMemToClass = async (newMember) => {
        console.log("Adding member to class:", newMember);

        if (!selectedClassForAdd) {
            console.error("No class selected");
            return;
        }

        try {
            const membersToAdd = Array.isArray(newMember) ? newMember : [newMember];


            // If parent provides invoice handler, use it
            if (onInvoiceRequest) {
                const invoiceData = {
                    scheduleinfo: selectedevent,
                    selectedMembers: membersToAdd.map(m => m._id),
                    memeberInfo: membersToAdd,
                    bussinessinfo: bussinessinfo,
                    discountMembers: discountData,
                    callbackUrl: callbackhandleCallback,
                    downloadInvoice: downloadInvoice
                };

                onInvoiceRequest(invoiceData);

                // Reset local states
                setShowAddMemberModal(false);
                setSelectedMembers([]);
                setDiscountData([]);
            } else {
                // Fallback to local invoice flow
                setSelectedMembers(membersToAdd);
                setShowAddMemberModal(false);
                setInvoiceCheck(true);
            }

        } catch (error) {
            console.error("Error adding member to class:", error);
            setAlertMessage({
                type: 'danger',
                text: 'Failed to add member to class. Please try again.',
                show: true
            });
            setTimeout(() => {
                setAlertMessage({ type: '', text: '', show: false });
            }, 5000);
        }
    };

    // Handler for submit from AddUsers component
    const onSubmitUser = () => {
        setSubmitFlag(true);
        setTimeout(() => {
            setSubmitFlag(false);
        }, 100);
    };

    const downloadInvoice = async (trans) => {
        try {
            if (trans == null) return;

            const update = {
                tid: trans.tid,
                bid: trans.bid,
                type: "class"
            };
            const response = await downloadclassinvoice(update, "user");
            const data = await response.json();

            if (data.url) {
                const link = document.createElement("a");
                link.href = data.url;
                link.setAttribute("download", "filename.pdf");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Error fetching signed URL", error);
        }
    };
    const callbackhandleCallback = () => {
        setInvoiceCheck(false);
        setSelectedMembers([]);
        setDiscountData([]);

        // Refresh the participants list
        if (selectedClassForAdd) {
            setClassParticipants(prev => {
                const updated = { ...prev };
                delete updated[selectedClassForAdd.id];
                return updated;
            });

            if (expandedClasses[selectedClassForAdd.id]) {
                loadParticipants(selectedClassForAdd.id, selectedClassForAdd);
            }
        }
    };


    const getClassStatusBadge = (session) => {
        const now = moment();

        if (session.startTime.isAfter(now)) {
            return {
                color: 'warning',
                text: 'Upcoming',
                icon: 'clock'
            };
        } else if (session.startTime.isBefore(now) && session.endTime.isAfter(now)) {
            return {
                color: 'success',
                text: 'In Progress',
                icon: 'play-circle'
            };
        } else if (session.endTime.isBefore(now)) {
            return {
                color: 'secondary',
                text: 'Completed',
                icon: 'check-circle'
            };
        } else {
            return {
                color: 'info',
                text: 'Scheduled',
                icon: 'calendar'
            };
        }
    };


    const CalenderInput = forwardRef(({ value, onClick }, ref) => (
        <>
            <span className="form-control select-input  placeholder-active me-3 shadow-1 d-flex align-items-center justify-content-between" onClick={onClick}>
                <p className="d-inline m-0 me-2">
                    {value === "" ? "Custom Range" : value}
                </p>
                <img src={calImg} alt="Custom Range" ref={ref} title="Select Custom Range" />
            </span>
        </>
    ));

    return (
        <div className="class-checkin-wrapper">
            <MDBAlert
                color={alertMessage.type}
                dismiss
                open={alertMessage.show}
                onClose={() => setAlertMessage({ type: '', text: '', show: false })}
                style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    zIndex: 9999,
                    maxWidth: '400px'
                }}
            >
                {alertMessage.text}
            </MDBAlert>


            <>

                {/* Search and Filter Header */}
                <div className="class-checkin-header mb-4">
                    <div className='d-flex flex-wrap'>
                        <div className="gym-section w-100-mobile w-30">
                            <label className="fw-bold"> Search: </label>
                            <MDBInput
                                label="Search classes, instructors, or types..."
                                value={searchClassQuery}
                                onChange={(e) => setSearchClassQuery(e.target.value)}
                            />
                        </div>
                        <div className="gym-section w-100-mobile ms-3">
                            <label className="fw-bold"> Days: </label>
                            <div>
                                <select
                                    style={{ height: '37px' }}
                                    name="shrs"
                                    id="shr"
                                    className="form-control select-input form-select placeholder-active me-3 shadow-1 "
                                    onChange={(e) => {
                                        setDayFilter(e.target.value);
                                        if (e.target.value !== '6') {
                                            setDateRange([null, null]);
                                        }
                                    }}
                                    value={dayFilter}
                                >
                                    {/* <option value="">All</option> */}
                                    <option value="1">Today</option>
                                    <option value="2">Yesterday</option>
                                    <option value="3">This Week</option>
                                    <option value="4">This Month</option>
                                    <option value="5">This Year</option>
                                    <option value="6">Custom</option>
                                </select>
                            </div>
                        </div>
                        <div className="gym-section w-100-mobile ms-3">
                            <label className="fw-bold"> Classes: </label>
                            <select
                                className="form-select"
                                style={{ height: '37px' }}
                                value={selectedFilter}
                                onChange={(e) => {
                                    setSelectedFilter(e.target.value);
                                    if (startDate || endDate) {
                                        setDateRange([null, null]);
                                    }
                                }}
                                disabled={(dayFilter !== '' && dayFilter !== '1') || !!(startDate && endDate)}
                            >
                                <option value="relevant">current Classes</option>
                                <option value="all">Today Classes</option>
                            </select>
                        </div>



                        {dayFilter === '6' && (
                            <div className="gym-section w-100-mobile ms-3">
                                <label className="fw-bold d-block">Date Range</label>
                                <div className="w_200px w-100-mobile">
                                    <div className="gym-xlarge gym-larg-pos">
                                        <DatePicker
                                            dateFormat={"d/M/yyyy"}
                                            selectsRange={true}
                                            startDate={startDate}
                                            endDate={endDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            isClearable={true}
                                            maxDate={addDays(new Date(), 365)}
                                            placeholderText="Select date range"
                                            customInput={<CalenderInput />}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </div>

                {loading ? (
                    <div className="text-center py-5">
                        <MDBSpinner color='primary' />
                        <p className="mt-3 text-muted">Loading classes...</p>
                    </div>
                ) : filteredClasses.length === 0 ? (
                    <div className="empty-state text-center py-5">
                        <MDBIcon fas icon="calendar-times" size="4x" className="text-muted mb-3" />
                        <h5 className="text-muted">No Classes Found</h5>
                        <p className="text-muted">
                            {dayFilter === '1' ? 'No classes found for today' :
                                dayFilter === '2' ? 'No classes found for yesterday' :
                                    dayFilter === '3' ? 'No classes found this week' :
                                        dayFilter === '4' ? 'No classes found this month' :
                                            dayFilter === '5' ? 'No classes found this year' :
                                                dayFilter === '6' && (!startDate || !endDate) ? 'Please select a date range' :
                                                    dayFilter === '6' && startDate && endDate ?
                                                        `No classes found between ${moment(startDate).format('MMM D')} and ${moment(endDate).format('MMM D, YYYY')}` :
                                                        startDate && endDate ?
                                                            `No classes found between ${moment(startDate).format('MMM D')} and ${moment(endDate).format('MMM D, YYYY')}` :
                                                            selectedFilter === 'relevant' ?
                                                                'No current classes found (past 2 hours, next hour, or in-progress)' :
                                                                'No classes scheduled for today'}
                        </p>
                    </div>
                ) : (
                    <div className="classes-list">

                        {startDate && endDate || dayFilter ? (
                            // Group by date with separators


                            (() => {
                                // Always group by date for better organization
                                const groupedClasses = {};

                                // Group classes by date
                                filteredClasses.forEach(session => {
                                    const dateKey = moment(session.startTime).format('YYYY-MM-DD');
                                    if (!groupedClasses[dateKey]) {
                                        groupedClasses[dateKey] = [];
                                    }
                                    groupedClasses[dateKey].push(session);
                                });

                                const sortedDates = Object.keys(groupedClasses).sort((a, b) => moment(a).diff(moment(b)));

                                return sortedDates.map(date => {
                                    // Get day name and formatted date
                                    const dateMoment = moment(date);
                                    const formattedDate = dateMoment.format('DD MMM YYYY');

                                    // Determine how to display the date
                                    let dateDisplay = formattedDate;

                                    const today = moment().startOf('day');

                                    // Show simplified relative dates
                                    if (dateMoment.isSame(today, 'day')) {
                                        dateDisplay = `Today`;
                                    } else if (dateMoment.isSame(today.clone().subtract(1, 'day'), 'day')) {
                                        dateDisplay = `Yesterday`;
                                    } else if (dateMoment.isSame(today.clone().add(1, 'day'), 'day')) {
                                        dateDisplay = `Tomorrow`;
                                    } else {
                                        // For all other dates, just show the date
                                        dateDisplay = formattedDate;
                                    }

                                    return (
                                        <React.Fragment key={date}>
                                            <div className="date-separator mb-3">
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-grow-1">
                                                        <hr className="my-0" />
                                                    </div>
                                                    <div className="px-3">
                                                        <span className="fw-bold text-primary bg-white px-2">
                                                            {dateDisplay}
                                                        </span>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <hr className="my-0" />
                                                    </div>
                                                </div>
                                            </div>

                                            {groupedClasses[date].map(session => {
                                                const isExpanded = expandedClasses[session.id];
                                                const participants = classParticipants[session.id] || [];
                                                console.log("ParticipantsParticipants:", participants);
                                                const statusBadge = getClassStatusBadge(session);

                                                const isLoading = loadingParticipants[session.id];
                                                const checkedInCount = session.checkedInCount || participants.filter(p => p.checkedIn).length;
                                                const enrolledCount = session.id in classParticipants ? participants.length : session.enrolled;

                                                return (
                                                    <MDBCard key={session.id} className="mb-3 border">
                                                        <MDBCardBody className="p-0">
                                                            <div
                                                                className="p-3 d-flex align-items-center class-header"
                                                                onClick={() => toggleClassExpand(session.id, session)}
                                                            >
                                                                {/* LEFT */}
                                                                <div className="d-flex align-items-center gap-2 class-left">
                                                                    <MDBIcon
                                                                        icon={isExpanded ? 'chevron-up' : 'chevron-down'}
                                                                        className="text-muted"
                                                                    />

                                                                    <div className='ms-3'>
                                                                        <h6 className="mb-2 fw-bold">
                                                                            {formatTimeDisplay(session.startTime, session.endTime)} - {session.className} Rs. {session.price}
                                                                        </h6>
                                                                        <span className="text-muted">
                                                                            <MDBIcon fas icon="users" className="me-1" />
                                                                            {enrolledCount} members, {session.instructor}
                                                                        </span>
                                                                    </div>

                                                                    <div className="status-badge-container">
                                                                        <MDBBadge
                                                                            color={statusBadge.color}
                                                                            className="me-2 px-2 py-1"
                                                                        >
                                                                            <MDBIcon
                                                                                fas
                                                                                icon={statusBadge.icon}
                                                                                className="me-1"
                                                                            />
                                                                            {statusBadge.text}
                                                                        </MDBBadge>
                                                                    </div>
                                                                </div>

                                                                {/* CENTER */}
                                                                <div className="class-center d-flex align-items-center gap-3">
                                                                    <span className="checkedin-pill">
                                                                        {checkedInCount}/{enrolledCount} Checked In
                                                                    </span>

                                                                    {/* {session.status !== 'completed' && ( */}

                                                                    <MDBBtn
                                                                        color="success"
                                                                        size="sm"
                                                                        outline
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            handleAddMemberClick(session);
                                                                        }}
                                                                    >
                                                                        + Add Participant
                                                                    </MDBBtn>


                                                                    {/*  )} */}
                                                                    <span
                                                                        className="view-link"
                                                                        onClick={(e) => handleViewClassInfo(e, session)}
                                                                    >
                                                                        View class info
                                                                    </span>
                                                                </div>
                                                            </div>

                                                            {isExpanded && (
                                                                <div className="border-top">
                                                                    {isLoading ? (
                                                                        <div className="text-center py-4">
                                                                            <MDBSpinner color='primary' size='sm' />
                                                                            <p className="mt-2 text-muted mb-0">Loading participants...</p>
                                                                        </div>
                                                                    ) : participants.length === 0 ? (
                                                                        <div className="text-center py-4">
                                                                            <p className="text-muted mb-0">No participants enrolled yet</p>
                                                                        </div>
                                                                    ) : (
                                                                        <MDBTable striped hover responsive className="checkinout-table">
                                                                            <MDBTableHead light>
                                                                                <tr>
                                                                                    <th>NAME</th>
                                                                                    <th>PHONE</th>
                                                                                    <th>PLAN</th>
                                                                                    <th>AGE</th>
                                                                                    <th>GENDER</th>
                                                                                    <th>STATUS</th>
                                                                                </tr>
                                                                            </MDBTableHead>
                                                                            <MDBTableBody>
                                                                                {participants.map((participant) => {
                                                                                    const loadingKey = `${session.id}-${participant._id}`;
                                                                                    const isLoadingCheckin = checkinLoading[loadingKey];

                                                                                    return (
                                                                                        <tr key={participant._id}>
                                                                                            <td>{participant.membername}</td>
                                                                                            <td>{participant.number}</td>
                                                                                            <td>{participant.plan}</td>
                                                                                            <td>{participant.age || '-'}</td>
                                                                                            <td>{participant.gender || '-'}</td>
                                                                                            <td>
                                                                                                {!participant.checkedIn ? (
                                                                                                    <MDBBtn
                                                                                                        size="sm"
                                                                                                        onClick={() => handleDirectCheckIn(session.id, participant)}
                                                                                                        disabled={isLoadingCheckin}
                                                                                                    >
                                                                                                        {isLoadingCheckin ? (
                                                                                                            <>
                                                                                                                <MDBSpinner size="sm" className="me-1" />
                                                                                                                Checking In...
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            'Check In'
                                                                                                        )}
                                                                                                    </MDBBtn>
                                                                                                ) : (
                                                                                                    <MDBBadge color="danger" className="px-3 py-2">
                                                                                                        Checked In
                                                                                                    </MDBBadge>
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    );
                                                                                })}
                                                                            </MDBTableBody>
                                                                        </MDBTable>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </MDBCardBody>
                                                    </MDBCard>
                                                );
                                            })}
                                        </React.Fragment>
                                    );
                                });
                            })()


                        ) : (
                            filteredClasses.map(session => {
                                const isExpanded = expandedClasses[session.id];
                                const participants = classParticipants[session.id] || [];
                                const isLoading = loadingParticipants[session.id];
                                const checkedInCount = session.checkedInCount || participants.filter(p => p.checkedIn).length;
                                const enrolledCount = session.id in classParticipants ? participants.length : session.enrolled;
                                const statusBadge = getClassStatusBadge(session); // Get the status badge info

                                return (
                                    <MDBCard key={session.id} className="mb-3 border">
                                        <MDBCardBody className="p-0">
                                            <div
                                                className="p-3 d-flex align-items-center class-header"
                                                onClick={() => toggleClassExpand(session.id, session)}
                                            >
                                                {/* LEFT */}
                                                <div className="d-flex align-items-center gap-2 class-left">
                                                    <MDBIcon
                                                        icon={isExpanded ? 'chevron-up' : 'chevron-down'}
                                                        className="text-muted"
                                                    />
                                                    <div className='ms-3'>
                                                        <h6 className="mb-2 fw-bold">
                                                            {formatTimeDisplay(session.startTime, session.endTime)} - {session.className} Rs. {session.price}
                                                        </h6>
                                                        <span className="text-muted">
                                                            <MDBIcon fas icon="users" className="me-1" />
                                                            {enrolledCount} members, {session.instructor}
                                                        </span>
                                                    </div>


                                                    <div className="status-badge-container">
                                                        <MDBBadge
                                                            color={statusBadge.color}
                                                            className="me-2 px-2 py-1"
                                                        >
                                                            <MDBIcon
                                                                fas
                                                                icon={statusBadge.icon}
                                                                className="me-1"
                                                            />
                                                            {statusBadge.text}
                                                        </MDBBadge>
                                                    </div>
                                                </div>

                                                {/* CENTER */}
                                                <div className="class-center d-flex align-items-center gap-3">
                                                    <span className="checkedin-pill">
                                                        {checkedInCount}/{enrolledCount} Checked In
                                                    </span>

                                                    {/* {session.status !== 'completed' && ( */}


                                                    <MDBBtn
                                                        color="success"
                                                        size="sm"
                                                        outline
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleAddMemberClick(session);
                                                        }}
                                                    >
                                                        + Add Participant
                                                    </MDBBtn>



                                                    {/* )} */}

                                                    <span
                                                        className="view-link"
                                                        onClick={(e) => handleViewClassInfo(e, session)}
                                                    >
                                                        View class info
                                                    </span>
                                                </div>
                                            </div>

                                            {isExpanded && (
                                                <div className="border-top">
                                                    {isLoading ? (
                                                        <div className="text-center py-4">
                                                            <MDBSpinner color='primary' size='sm' />
                                                            <p className="mt-2 text-muted mb-0">Loading participants...</p>
                                                        </div>
                                                    ) : participants.length === 0 ? (
                                                        <div className="text-center py-4">
                                                            <p className="text-muted mb-0">No participants enrolled yet</p>
                                                        </div>
                                                    ) : (
                                                        <MDBTable striped hover responsive className="checkinout-table">
                                                            <MDBTableHead light>
                                                                <tr>
                                                                    <th>NAME</th>
                                                                    <th>PHONE</th>
                                                                    <th>PLAN</th>
                                                                    <th>AGE</th>
                                                                    <th>GENDER</th>
                                                                    <th>STATUS</th>
                                                                </tr>
                                                            </MDBTableHead>
                                                            <MDBTableBody>
                                                                {participants.map((participant) => {
                                                                    const loadingKey = `${session.id}-${participant._id}`;
                                                                    const isLoadingCheckin = checkinLoading[loadingKey];

                                                                    return (
                                                                        <tr key={participant._id}>
                                                                            <td>{participant.membername}</td>
                                                                            <td>{participant.number}</td>
                                                                            <td>{participant.plan}</td>
                                                                            <td>{participant.age || '-'}</td>
                                                                            <td>{participant.gender || '-'}</td>
                                                                            <td>
                                                                                {!participant.checkedIn ? (
                                                                                    <MDBBtn
                                                                                        size="sm"
                                                                                        onClick={() => handleDirectCheckIn(session.id, participant)}
                                                                                        disabled={isLoadingCheckin}
                                                                                    >
                                                                                        {isLoadingCheckin ? (
                                                                                            <>
                                                                                                <MDBSpinner size="sm" className="me-1" />
                                                                                                Checking In...
                                                                                            </>
                                                                                        ) : (
                                                                                            'Check In'
                                                                                        )}
                                                                                    </MDBBtn>
                                                                                  ) : (
                                                                                    <MDBBadge color="danger" className="px-3 py-2">
                                                                                        Checked In
                                                                                    </MDBBadge>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </MDBTableBody>
                                                        </MDBTable>
                                                    )}
                                                </div>
                                            )}
                                        </MDBCardBody>
                                    </MDBCard>
                                );
                            })
                        )}
                    </div>
                )}
            </>
            {/* Keep both modals outside - they should still work */}
            <MDBModal
                open={showAddMemberModal}
                onClose={() => {
                    setShowAddMemberModal(false);
                    setSelectedClassForAdd(null);
                }}
                tabIndex="-1"
            >
                <MDBModalDialog centered size="lg">
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                Add Participant to {selectedClassForAdd?.className}
                            </MDBModalTitle>
                            <MDBBtn
                                className="btn-close"
                                color="none"
                                onClick={() => {
                                    setShowAddMemberModal(false);
                                    setSelectedClassForAdd(null);
                                }}
                            />
                        </MDBModalHeader>

                        <MDBModalBody>
                            <AddUsers
                                id={getToken()}
                                index={curIndex}
                                onsubmit={onSubmitUser}
                                submit={submitFlag}
                                onAdd={addMemToClass}
                            />
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal
                open={showClassInfoModal}
                onClose={() => setShowClassInfoModal(false)}
                tabIndex="-1"
            >
                <MDBModalDialog size="lg">
                    <MDBModalContent style={{ maxHeight: '70%' }}>
                        {/* Header */}
                        <MDBModalHeader>
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <MDBTypography tag="h6" className="m-0 p-0">
                                    {selectedClassInfo?.className || "Class Information"}
                                </MDBTypography>
                                <MDBBtn
                                    className="btn-close ms-3"
                                    color="none"
                                    onClick={() => setShowClassInfoModal(false)}
                                />
                            </div>
                        </MDBModalHeader>

                        {/* Body */}
                        <MDBModalBody className="p-4">
                            {selectedClassInfo && (
                                <table className="table table-striped table-bordered compressed-table mb-0">
                                    <tbody>
                                        <tr>
                                            <td width="150px">Time</td>
                                            <td>
                                                {formatTimeDisplay(
                                                    selectedClassInfo.startTime,
                                                    selectedClassInfo.endTime
                                                )}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>Instructor</td>
                                            <td>{selectedClassInfo.instructor || "—"}</td>
                                        </tr>

                                        <tr>
                                            <td>Category</td>
                                            <td>{selectedClassInfo.category || "—"}</td>
                                        </tr>

                                        <tr>
                                            <td>Level</td>
                                            <td>{selectedClassInfo.level || "—"}</td>
                                        </tr>

                                        <tr>
                                            <td>Duration</td>
                                            <td>{selectedClassInfo.duration} mins</td>
                                        </tr>

                                        <tr>
                                            <td>Price</td>
                                            <td>₹{selectedClassInfo.price}</td>
                                        </tr>

                                        <tr>
                                            <td>Capacity</td>
                                            <td>{selectedClassInfo.capacity}</td>
                                        </tr>

                                        <tr>
                                            <td>Description</td>
                                            <td>
                                                <p className="mb-0 text-wrap">
                                                    {selectedClassInfo.classDescription || "—"}
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </MDBModalBody>

                        {/* Footer */}
                        <MDBModalFooter className="px-3 pb-2">
                            <MDBBtn
                                color="secondary"
                                onClick={() => setShowClassInfoModal(false)}
                            >
                                Close
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>




        </div >
    );
};


export default ClassCheckIn;